import { ErrorCode } from '@billing/utils/ErrorCode/error-code-enum'
import { useTranslate } from '@tolgee/react'
import { getAllErrorDescriptions } from '@tom-ui/utils'

export const useOperationEquipmentMessageHandler = () => {
  const { t } = useTranslate()

  const getExceptionMessage = (error: any) => {
    const errorDescriptions = getAllErrorDescriptions(error)

    const errors: string[] = []

    errorDescriptions.forEach(errorDescription => {
      if (errorDescription.code === ErrorCode.NotFoundException) {
        errors.push(
          t('entityNotFound', '{entity} with Id {id} not found', {
            entity: errorDescription.payload?.name,
            id: errorDescription.payload?.id,
          }),
        )
      }
      if (errorDescription.code === ErrorCode.CommoditiesAlreadyExistInOrders) {
        errors.push(
          t('commoditiesAlreadyInOrder', 'Commodities with codes {codes} already exist in orders', {
            codes: errorDescription.payload?.codes,
          }),
        )
      }
      if (errorDescription.code === ErrorCode.CommoditiesAlreadyExistInTheCatalogue) {
        errors.push(
          t(
            'commoditiesAlreadyInCatalogue',
            'Commodities with codes {codes} already exist in the catalogue',
            {
              codes: errorDescription.payload?.codes,
            },
          ),
        )
      }
      if (errorDescription.code === ErrorCode.AlreadyExist) {
        errors.push(
          t('commodityAlreadyExists', 'Commodity with code {code} already exists', {
            code: errorDescription.payload?.code,
          }),
        )
      }
      if (errorDescription.code === ErrorCode.InvalidOperation) {
        errors.push(
          t('invalidOperation', 'Invalid operation: {message}', {
            message: errorDescription.payload?.message,
          }),
        )
      }
    })

    if (errors.length > 0) return errors.join('\n')

    return error?.response?.data?.detail ?? t('somethingWentWrong', 'Something went wrong')
  }

  return {
    getExceptionMessage,
  }
}
